import PropTypes from "prop-types";
import DataGridCell from "./DataGridCell";
import SortableTable from "./SortableTable";
import { getStylebyVC } from "../util/styleHelper";
import Box from "@mui/material/Box/Box";

const columns = [
  { field: "id", headerName: "#", flex: 0.25 },
  {
    field: "uniqueName",
    headerName: "Name",
    headerClassName: "super-app-theme--header",
    width: 200,
    style: "bold",
    renderCell: ({ value }) => <DataGridCell value={value} />,
  },
  {
    field: "maxVC",
    headerName: "Max V/C",
    flex: 0.5,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      return (
        <Box
          style={{
            ...getStylebyVC(params.value),
            padding: "10px 0px 10px 0px",
            minWidth: "100%",
            textAlign: "center",
          }}
        >
          {params.value}
        </Box>
      );
    },
  },
  {
    field: "openingYearAmPeak",
    headerName: "AM Peak",
    flex: 0.5,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "openingYearPmPeak",
    headerName: "PM Peak",
    flex: 0.5,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "openingYearWeekendPeak",
    headerName: "Weekend Peak",
    flex: 0.5,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "designYearAmPeak",
    headerName: "AM Peak",
    flex: 0.5,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "designYearPmPeak",
    headerName: "PM Peak",
    flex: 0.5,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "designYearWeekendPeak",
    headerName: "Weekend Peak",
    flex: 0.5,
    headerAlign: "center",
    align: "center",
  },
];

const columnGroupingModel = [
  {
    groupId: "Opening Year V/C",
    description: "",
    children: [
      { field: "openingYearAmPeak" },
      { field: "openingYearPmPeak" },
      { field: "openingYearWeekendPeak" },
    ],
  },
  {
    groupId: "Design Year V/C",
    description: "",
    children: [
      { field: "designYearAmPeak" },
      { field: "designYearPmPeak" },
      { field: "designYearWeekendPeak" },
    ],
  },
];

export default function VcTable({ rows }) {
  return (
    <SortableTable
      columnGroupingModel={columnGroupingModel}
      columns={columns}
      rows={rows}
    />
  );
}

VcTable.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.object).isRequired,
};
